module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    ref: "depentConfig",
    attrs: {
      "title": "配置从属字段",
      "size": "small"
    }
  }, [_c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.keyDepent
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "从属字段"
    },
    scopedSlots: {
      default: function(scope) {
        return [_c('el-select', {
          directives: [{
            name: "model",
            rawName: "v-model",
            value: (scope.row.name),
            expression: "scope.row.name"
          }],
          staticClass: "w-150 m-r-10",
          attrs: {
            "placeholder": "从属字段"
          },
          domProps: {
            "value": (scope.row.name)
          },
          on: {
            "input": function($event) {
              scope.row.name = $event
            }
          }
        }, _vm._l((_vm.showName), function(option) {
          return _c('el-option', {
            attrs: {
              "label": option,
              "value": option
            }
          })
        }))]
      }
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "字段标题"
    },
    scopedSlots: {
      default: function(scope) {
        return [_c('el-input', {
          directives: [{
            name: "model",
            rawName: "v-model",
            value: (scope.row.title),
            expression: "scope.row.title"
          }],
          staticClass: "w-150 m-r-10",
          attrs: {
            "placeholder": "字段标题"
          },
          domProps: {
            "value": (scope.row.title)
          },
          on: {
            "input": function($event) {
              scope.row.title = $event
            }
          }
        })]
      }
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作"
    },
    scopedSlots: {
      default: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "small",
            "type": "danger"
          },
          on: {
            "click": function($event) {
              _vm.deleteRow(scope.$index)
            }
          }
        }, [_vm._v("删除")])]
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "tx-c m-t-10"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.addRow
    }
  }, [_vm._v("添加一行")])]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": _vm.closeDialog
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.confirmDepentConfig
    }
  }, [_vm._v("确 定")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-0bea882f!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Common/business/inputConfig/depentConfig.vue
// module id = 1767
// module chunks = 2